export const passengersInfoType = {
  adult: {
    title: "passengers.type.adult.title",
    info: "passengers.type.adult.info",
  },
  child: {
    title: "passengers.type.child.title",
    info: "passengers.type.child.info",
  },
  pupil: {
    title: "passengers.type.pupil.title",
    info: "passengers.type.pupil.info",
  },
  youth: {
    title: "passengers.type.youth.title",
    info: "passengers.type.youth.info",
  },
  senior: {
    title: "passengers.type.senior.title",
    info: "passengers.type.senior.info",
  },
};
